import * as React from "react";
import {FC, useState} from "react";
import {Images} from "../Images";
import {makeStyles} from "@mui/styles";
import {DialogContent, DialogTitle, useMediaQuery, useTheme} from "@mui/material";
import {GlobalLayout, ImageDialog, StyledDiv, StyledTypography} from "../providers/layout/LayoutProvider";
import {CloseIcon} from "../svg/SvgIcons";
import {useRecoilValue} from "recoil";
import clsx from "clsx";

type ImageViewProps = {
   src: string
   title?: string
   size: number
}

export const ImageView: FC<ImageViewProps> = ({src, title, size}) => {
   const [preview, setPreview] = useState<boolean>(false);
   const classes = useStyles();
   const theme = useTheme();
   const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
   const globalLayout = useRecoilValue(GlobalLayout);

   return <>
      <ImageDialog
         backgroundImage={src} open={preview} maxWidth={"lg"} fullWidth={true} fullScreen={fullScreen}
         onClose={() => setPreview(false)}>
            <DialogTitle className={classes.titleFrame}>
               <StyledDiv type={"main"} className={classes.titleContainer} style={{
                  backgroundColor: globalLayout.widgets?.cartBackgroundColor||undefined,
                  color: globalLayout.widgets?.cartTextColor||undefined
               }}>
                  <StyledTypography variant={"h1"} type={"contrast"}>{title}</StyledTypography>
               </StyledDiv>
               <div className={classes.closeDialog} onClick={() => setPreview(false)}>
                  <CloseIcon fontSize={"large"} iconcolor={globalLayout.widgets?.cartTextColor||'#FF5376'}/>
               </div>
            </DialogTitle>
         <DialogContent className={classes.previewDialog}>
            <div className={classes.previewContent}>
               &nbsp;
            </div>
         </DialogContent>
      </ImageDialog>
      <div className={clsx(classes.imageContainer, 'c2s-imageview-container')} onClick={() => setPreview(true)}>
         <img
            src={Images.NOT_FOUND}
            className={clsx(classes.image, 'c2s-imageview-image')}
            style={{
               backgroundImage: 'url(' + src + ')',
               backgroundRepeat: "no-repeat",
               backgroundSize: "contain",
               backgroundPosition: "center",
               cursor: 'pointer',
               width: size + 'px'
            }}
            title={title || 'Click for preview'}
            alt={title || ''}
         />
      </div>
   </>
}

const useStyles = makeStyles({
   imageContainer: {},
   image: {

   },
   previewDialog: {
      minHeight: '90vh'
   },
   previewContent: {
      position: 'relative',
   },
   previewImage: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
   },
   closeDialog: {
      position: 'absolute',
      right: '10px',
      top: '10px',
      cursor: 'pointer'
   },
   titleFrame: {
      margin: 0,
      padding: 0
   },
   titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      backgroundColor: '#F4E4BA',
      padding: '5px 20px 5px 20px'
   }

});